import React, { useState } from 'react';
import '../App.css';

/**
 * Modal para recusa de convite com justificativa obrigatória
 * @param {Object} props
 * @param {boolean} props.isOpen - Se o modal está aberto
 * @param {Function} props.onClose - Callback para fechar o modal
 * @param {Function} props.onRecusar - Callback ao confirmar recusa (recebe justificativa)
 * @param {Object} props.convite - Dados do convite sendo recusado
 */
function RecusaConviteModal({ isOpen, onClose, onRecusar, convite }) {
    const [justificativa, setJustificativa] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isOpen || !convite) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!justificativa.trim()) {
            alert('Por favor, informe uma justificativa para a recusa.');
            return;
        }

        if (justificativa.trim().length < 10) {
            alert('A justificativa deve ter pelo menos 10 caracteres.');
            return;
        }

        setIsSubmitting(true);

        try {
            await onRecusar(justificativa.trim());
            setJustificativa('');
            onClose();
        } catch (error) {
            console.error('Erro ao recusar convite:', error);
            alert('Erro ao recusar convite. Tente novamente.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        if (!isSubmitting) {
            setJustificativa('');
            onClose();
        }
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 3000 }} onClick={handleClose}>
            <div
                className="modal-content"
                style={{ maxWidth: '500px' }}
                onClick={e => e.stopPropagation()}
            >
                <div style={{
                    background: 'linear-gradient(135deg, #dc3545, #c82333)',
                    color: '#fff',
                    padding: '20px',
                    borderRadius: '8px 8px 0 0',
                    marginBottom: '20px'
                }}>
                    <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                        ❌ Recusar Convite
                    </h3>
                </div>

                <div style={{ padding: '0 20px 20px 20px' }}>
                    {/* Informações do Convite */}
                    <div style={{
                        backgroundColor: '#f8f9fa',
                        padding: '15px',
                        borderRadius: '8px',
                        marginBottom: '20px',
                        borderLeft: '4px solid #dc3545'
                    }}>
                        <h4 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '16px' }}>
                            {convite.descricao || convite.auditoria || 'Evento'}
                        </h4>
                        <div style={{ fontSize: '14px', color: '#666' }}>
                            <div style={{ marginBottom: '5px' }}>
                                <strong>📅 Data:</strong> {new Date(convite.data + 'T00:00:00').toLocaleDateString('pt-BR')}
                            </div>
                            <div style={{ marginBottom: '5px' }}>
                                <strong>⏰ Horário:</strong> {convite.horario}
                            </div>
                            {convite.setor && (
                                <div>
                                    <strong>📍 Setor:</strong> {convite.setor}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Formulário de Justificativa */}
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="justificativa" style={{ fontWeight: '600', marginBottom: '8px', display: 'block' }}>
                                Justificativa da Recusa <span style={{ color: '#dc3545' }}>*</span>
                            </label>
                            <textarea
                                id="justificativa"
                                value={justificativa}
                                onChange={(e) => setJustificativa(e.target.value)}
                                placeholder="Ex: Conflito de horário com outra reunião, ausência programada, etc."
                                required
                                minLength={10}
                                maxLength={500}
                                rows={5}
                                style={{
                                    width: '100%',
                                    padding: '12px',
                                    borderRadius: '6px',
                                    border: '1px solid #ddd',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    resize: 'vertical',
                                    boxSizing: 'border-box'
                                }}
                                disabled={isSubmitting}
                            />
                            <div style={{
                                fontSize: '12px',
                                color: '#666',
                                marginTop: '5px',
                                textAlign: 'right'
                            }}>
                                {justificativa.length}/500 caracteres (mínimo 10)
                            </div>
                        </div>

                        {/* Aviso */}
                        <div style={{
                            backgroundColor: '#fff3cd',
                            border: '1px solid #ffc107',
                            borderRadius: '6px',
                            padding: '12px',
                            marginBottom: '20px',
                            fontSize: '13px',
                            color: '#856404'
                        }}>
                            <strong>⚠️ Atenção:</strong> O criador do evento será notificado sobre sua recusa e poderá reagendar.
                        </div>

                        {/* Botões */}
                        <div className="modal-actions" style={{ marginTop: '20px' }}>
                            <button
                                type="button"
                                className="btn-cancel"
                                onClick={handleClose}
                                disabled={isSubmitting}
                            >
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                className="btn-excluir"
                                disabled={isSubmitting || justificativa.trim().length < 10}
                                style={{
                                    backgroundColor: isSubmitting ? '#ccc' : '#dc3545',
                                    cursor: isSubmitting ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {isSubmitting ? 'Recusando...' : 'Confirmar Recusa'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default RecusaConviteModal;
